import React from "react";
import { PillToggle } from "../ui";
import { formatSessionDatePill } from "../../lib/classDashboard";

export default function SessionDateSelector({ instances = [], selectedId, onSelect }) {
  if (!instances.length) return null;

  return (
    <div className="max-w-page mx-auto px-4 mt-4" data-testid="class-dash-date-selector">
      <div
        className="flex gap-2 overflow-x-auto pb-1 snap-x snap-mandatory [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        role="listbox"
        aria-label="Class session dates"
      >
        {instances.map((inst) => {
          const id = inst.id || inst._id;
          const iso = inst.effective_datetime || inst.datetime;
          const cancelled = inst.status === "CANCELLED";
          const active = selectedId === id;
          return (
            <PillToggle
              key={id}
              active={active}
              onClick={() => onSelect(id)}
              className={`snap-start shrink-0 ${cancelled ? "opacity-60" : ""}`}
              data-testid={`class-dash-date-${id}`}
              aria-selected={active}
              role="option"
            >
              {formatSessionDatePill(iso)}
              {cancelled ? " · Cancelled" : ""}
            </PillToggle>
          );
        })}
      </div>
    </div>
  );
}
